export const IMAGE_URL = 'https://fabikraft-dev.ewr1.vultrobjects.com';
